export class ResetPasswordByUserRequest {
    emailAddress: string;
    userId:string;
newPassword:string;
    constructor(

        emailAddress: string = "",
        userId: string ="",
        newPassword:string ="",
    ) { 

        this.emailAddress = emailAddress;
       this.userId =userId
       this.newPassword= newPassword
    }

}